import {
  CHANGE_THEME,
  CHANGE_LANG,
  INITIALIZE,
  LOGGED_IN,
  USER_PROFILE,
  USER_BILL_DETAILS,
  GROUPS_CATEGORIES_DATA,
  CLIENT_CONFIG_DETAILS,
  SELECTED_CATEGORY,
  NUMBER_FOR_RECHARGE,
  SELECTED_BILLER,
  NOTIFICATION_DATA
} from "./Types";

const Reducer = (state, action) => {
  switch (action.type) {
    case CHANGE_THEME:
      return { ...state, theme: action.payload };
    case CHANGE_LANG:
      return { ...state, lang: action.payload };
    case INITIALIZE:
      return { ...state, ...action.payload };
    case LOGGED_IN:
      return { ...state, ...action.payload };
    case USER_PROFILE:
      return { ...state, ...action.payload };
    case USER_BILL_DETAILS:
      return { ...state, ...action.payload };
    case GROUPS_CATEGORIES_DATA:
      return { ...state, ...action.payload };
    case CLIENT_CONFIG_DETAILS:
      return { ...state, ...action.payload };
    case SELECTED_CATEGORY:
      return { ...state, ...action.payload };
    case SELECTED_BILLER:
      return { ...state, ...action.payload };
    case NUMBER_FOR_RECHARGE:
      return { ...state, ...action.payload };
    case NOTIFICATION_DATA:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default Reducer;
